import { MEDUSA_BACKEND_URL } from '@lib/config';
import { CLIENT_API_KEY } from '@lib/constants/variants';
import objectToURLSearchParams from '@lib/util/object-to-url-search-params';
import {
    buildApiResult,
    fetchWithTimeout,
    FetchWithTimeoutOptions,
    handleHttpErrors,
} from './api-util';
import { fetch_timeout_duration } from '@lib/constants/network-constants';

const MEDUSA_API_KEY = process.env.MEDUSA_API_KEY || '';
const REVALIDATE_WINDOW = process.env.REVALIDATE_WINDOW || 60 * 30; // 30 minutes

export default async function apiRequest(
    method: string,
    path: string = '',
    payload?: {
        query?: Record<string, any>;
        body?: Record<string, any>;
    },
    auth_token?: string,
    no_cache?: boolean,
    root?: string,
    timeout: number = fetch_timeout_duration,
    no_cors?: boolean
) {
    const options: RequestInit = {
        method,
        headers: {
            'Content-Type': 'application/json',
            'x-publishable-key': MEDUSA_API_KEY,
            'x-api-key': CLIENT_API_KEY,
        },
        next: {
            revalidate: parseInt(REVALIDATE_WINDOW.toString()),
            tags: ['api_request'],
        },
        credentials: 'include',
    };
    if (auth_token) {
        options.headers = {
            'Content-Type': 'application/json',
            'x-publishable-key': MEDUSA_API_KEY,
            'x-auth-token': auth_token,
            'x-api-key': CLIENT_API_KEY,
        };
    }

    if (no_cache) {
        options.cache = 'no-cache';
        options.next!.revalidate = 0;
    }

    if (payload?.body) {
        options.body = JSON.stringify(payload.body);
    }

    if (payload?.query) {
        const params = objectToURLSearchParams(payload.query).toString();
        path = `${path}?${params}`;
    }

    if (no_cors) {
        options.headers = {
            'Content-Type': 'text/plain',
        };
    }

    try {
        const fetchWithTimeoutOptions: FetchWithTimeoutOptions = {
            timeout,
            ...options,
        };

        const response = await fetchWithTimeout(
            `${MEDUSA_BACKEND_URL}${root || ''}${path}`,
            fetchWithTimeoutOptions
        );
        if (!response?.ok) {
            const error = await response?.json();
            if (error?.message) {
                throw new Error(error?.message);
            }
            try {
                await handleHttpErrors(response);
            } catch (error) {}
        }
        let body;
        try {
            body = await response?.json();
        } catch (error) {
            console.error('Failed to parse JSON response:', error);
            body = null; // Or handle accordingly
        }

        if (body?.errors) {
            console.error(body.errors);
            throw body.errors[0];
        }

        const apiResult = buildApiResult(response, body);
        return apiResult;
    } catch (error: any) {
        throw error;
    }
}
